module.exports = __webpack_public_path__ + "img/materiauxamaconner.ccdfe944.webp";